import { api } from "./http";

const toPage = (res) => res.data;

const NotificationApi = {
  list: async ({ page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const params = { page, size, sort };
    return toPage(await api.get("/notifications", { params }));
  },

  latest: async ({ page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const params = { page, size, sort };
    return toPage(await api.get("/notifications/latest", { params }));
  },

  unread: async ({ page = 0, size = 20, sort = "createdAt,desc" } = {}) => {
    const params = { page, size, sort };
    return toPage(await api.get("/notifications/unread", { params }));
  },

  unreadCount: async () => (await api.get("/notifications/unread/count")).data, 

  markRead: async (uuid) => (await api.post(`/notifications/${uuid}/read`)).status === 204,

  markAllRead: async () => (await api.post("/notifications/read-all")).data, 

  remove: async (uuid) => (await api.delete(`/notifications/${uuid}`)).data,
};

export default NotificationApi;
